import { useMemo } from 'react';
import { store }   from 'index';

const useNavbarStyle = (
    bigNavBar:  boolean,
) => {

  const state          = store.getState();
  const { showNavBar } = state.components;
  const sizeState      = state.size;

  const [ rootStyle, containerStyle, logoStyle ] = useMemo(() => {

     const { navBarSize, size } = sizeState;

     return[
       {
          top:    showNavBar ? 0 : -navBarSize,
          height: navBarSize
       },
       {
         height:     navBarSize,
         width:      !bigNavBar ? 100 : (size[0] * 0.85) - 60,
         left:       !bigNavBar ? 90 : 60,
       },
       {
        height: navBarSize
       }
     ]
  },[showNavBar, bigNavBar, sizeState])

  return { rootStyle, containerStyle, logoStyle }


}

export default useNavbarStyle